import env from '../../env.js';

export const logoMixin = {
    computed: {
        /**
         * Obtiene el logo actual según el entorno
         * @returns {string} URL del logo
         */
        currentLogo() {
            return env.getCurrentLogo();
        },
        
        /**
         * Obtiene el entorno actual
         * @returns {string} 'development' o 'production'
         */
        currentEnvironment() {
            return env.environment;
        },
        
        /**
         * Verifica si estamos en desarrollo
         * @returns {boolean}
         */
        isDevelopment() {
            return env.environment === 'development';
        },
        
        /**
         * Verifica si estamos en producción
         * @returns {boolean}
         */
        isProduction() {
            return env.environment === 'production';
        }
    },
    
    methods: {
        /**
         * Obtiene un logo específico por tipo de entorno
         * @param {string} environment - 'development' o 'production'
         * @returns {string} URL del logo
         */
        getLogoByEnvironment(environment) {
            return env.logos[environment] || env.logos.production;
        }
    }
};

export default logoMixin;
